import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { JsonValidationService } from '../../../../../shared/src/lib/services/json-validation-service/json-validation.service';
import { NotificationService } from '../../services';

@Component({
  selector: 'rappider-json-editor-modal',
  templateUrl: './json-editor-modal.component.html',
  styleUrls: ['./json-editor-modal.component.scss']
})
export class RappiderJsonEditorModalComponent implements OnChanges {

  /* JSON data */
  @Input() data: any = {};
  /* Modal title */
  @Input() title = 'Edit JSON';
  /* Modal visibility */
  @Input() visible = false;
  /* Modal width */
  @Input() width = '70%';

  /* Modal close event */
  @Output() visibleChange = new EventEmitter<boolean>();
  /* JSON data change event */
  @Output() dataChange = new EventEmitter<any>();

  editorReady = false;
  isJsonValid = true;
  stringifiedData: string;

  CODEMIRROR_JSON_SETTINGS = {
    language: 'json',
    automaticLayout: true,
    minimap: {
      enabled: false
    },
    formatOnPaste: true,
    formatOnType: true,
    validateOnType: false,
    validateOnPaste: false
  };

  constructor(
    private jsonValidationService: JsonValidationService,
    private notificationService: NotificationService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.visible && changes.visible.currentValue === true) {
      this.prepareEditor();
    }

    if (changes.data && changes.data.currentValue && this.visible) {
      this.prepareJsonData();
    }
  }

  /**
   * JSON data changes
   * @param data Changed JSON data
   */
  onDataChange(data: string) {
    this.stringifiedData = data;
    this.isJsonValid = true;
  }

  /**
   * Prepares JSON data for the editor
   */
  prepareJsonData() {
    try {
      if (typeof this.data !== 'string') {
        this.stringifiedData = JSON.stringify(this.data, null, 2);
      } else {
        try {
          const parsed = JSON.parse(this.data);
          this.stringifiedData = JSON.stringify(parsed, null, 2);
        } catch (e) {
          this.stringifiedData = this.data;
        }
      }
      this.isJsonValid = true;
    } catch (error) {
      this.stringifiedData = '{}';
      this.isJsonValid = true;
    }
  }

  prepareEditor() {
    this.editorReady = false;
    this.isJsonValid = true;
    this.prepareJsonData();
    setTimeout(() => {
      this.editorReady = true;
    }, 10);
  }

  saveChanges() {
    try {
      if (!this.stringifiedData) {
        this.data = {};
        this.dataChange.emit(this.data);
        this.notificationService.createNotification(
          'success',
          'Success',
          'JSON saved successfully'
        );
        this.closeModal();
        return;
      }

      if (typeof this.stringifiedData !== 'string') {
        this.data = this.stringifiedData;
        this.dataChange.emit(this.data);
        this.notificationService.createNotification(
          'success',
          'Success',
          'JSON saved successfully'
        );
        this.closeModal();
        return;
      }

      if (this.stringifiedData.trim() === '') {
        this.data = {};
        this.dataChange.emit(this.data);
        this.notificationService.createNotification(
          'success',
          'Success',
          'JSON saved successfully'
        );
        this.closeModal();
        return;
      }

      const parsedData = JSON.parse(this.stringifiedData);

      this.data = parsedData;
      this.dataChange.emit(this.data);

      this.notificationService.createNotification(
        'success',
        'Success',
        'JSON saved successfully'
      );

      setTimeout(() => {
        this.closeModal();
      }, 300);
    } catch (error) {
      this.isJsonValid = false;

      this.notificationService.createNotification(
        'error',
        'JSON Error',
        'Invalid JSON format'
      );
    }
  }

  closeModal() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.editorReady = false;
  }

  openModal() {
    this.visible = true;
    this.visibleChange.emit(true);
    this.prepareEditor();
  }
}
